export default function ProvablySeedPair(obj: any) {
  const {
    client_seed,
    server_seed_SHA256,
    nonce,
    old_client_seed,
    old_server_seed,
    old_server_seed_SHA256,
    old_nonce,
    next_server_seed_SHA256
  } = obj

  const CurrentSeedPair = [
    {
      Title: 'Clients seed',
      Content: client_seed ? client_seed : 'clients seed',
      enableCopy: client_seed ? true : false
    },
    {
      Title: 'Server seed hash',
      Content: server_seed_SHA256 ? server_seed_SHA256 : 'server seed hash',
      enableCopy: server_seed_SHA256 ? true : false
    },
    {
      Title: 'Nonce',
      Content: nonce ? nonce : 0,
      enableCopy: nonce ? true : false
    },
    {
      Title: 'Next server seed hash',
      Content: next_server_seed_SHA256
        ? next_server_seed_SHA256
        : 'next server seed hash',
      enableCopy: next_server_seed_SHA256 ? true : false
    }
  ]
  const PreviousSeedPair = [
    {
      Title: 'Clients seed',
      Content: old_client_seed ? old_client_seed : 'clients seed',
      enableCopy: old_client_seed ? true : false
    },
    {
      Title: 'Server seed',
      Content: old_server_seed ? old_server_seed : 'server seed',
      enableCopy: old_server_seed ? true : false
    },
    {
      Title: 'Server seed hash',
      Content: old_server_seed_SHA256
        ? old_server_seed_SHA256
        : 'server seed hash',
      enableCopy: old_server_seed_SHA256 ? true : false
    },
    {
      Title: 'Nonce',
      Content: old_nonce ? old_nonce : 0,
      enableCopy: old_nonce ? true : false
    }
  ]
  return { CurrentSeedPair, PreviousSeedPair }
}
